import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "../models/apiresponse";
import { environment } from "src/environments/environment";
import { catchError, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ConsentService {
  constructor(protected httpClient: HttpClient) {}

  private getRequestHeader(isGetApi: boolean) {
    return isGetApi
      ? {
          headers: new HttpHeaders({
            "x-api-key": environment.apikey,
          }),
        }
      : {
          headers: new HttpHeaders({
            languageId: "1",
            channel: "ssp",
            "Content-Type": "application/json",
            "x-api-key": environment.apikey,
          }),
        };
  }

  acceptConsent(caId: string) {
    return this.httpClient
      .post<ApiResponse>(
        environment.apiurl + "/consent/",
        {
          caId: caId,
        },
        this.getRequestHeader(false),
      )
      .pipe(
        map((response: ApiResponse) => {
          return response;
        }),
        catchError((error) => {
          console.log(error.message);
          throw new Error(error?.statusText);
        }),
      );
  }
}
